<div class="teamMemberList">
  <div class="header">
    <div><h2>Team Member Index</h2></div>
    <div class="memberCount">{{ teamMembers.length }} members</div>
    <div class="filterLabel">Filter by</div>
    <div class="personalityTypeSelect">
      <mat-form-field appearance="fill" class="personalityType" floatLabel="never">
        <mat-label>Personality Type</mat-label>
        <mat-select
          id="personalityType"
          matInput
          [(ngModel)]="personalityTypeFilter"
          (selectionChange)="applyFilter()"
          disableOptionCentering
          panelClass="dropDown-overlay"
        >
          <mat-option *ngFor="let personalityType of personalityTypes" [value]="personalityType.substring(0, 4)">{{ personalityType }}</mat-option>
        </mat-select>
        <button mat-button mat-icon-button matSuffix (click)="clearFilter()" class="clear-button" *ngIf="personalityTypeFilter" aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
  <div class="d-none d-md-block d-lg-block d-xl-block">
    <div class="teamListContainer">
      <div class="teamList d-flex flex-column">
        <ng-container *ngFor="let teamMember of teamMembers; let i = index">
          <div
            *ngIf="teamMember.status === 'Completed'"
            class="teamMember d-flex"
            (mouseenter)="teamMemberHover(teamMember); isTeamMemberHovered[i] = true"
            (mouseleave)="teamMemberUnHover(); isTeamMemberHovered[i] = false"
          >
            <div class="initials" [ngStyle]="{ background: teamMember.color }">{{ teamMember.initials }}</div>
            <div class="name">
              <span>{{ teamMember.firstName }} {{ teamMember.lastName }}</span>
            </div>
            <div class="profileLink ms-auto" *ngIf="teamMember.currentUser">You</div>
            <div *ngIf="!teamMember.currentUser && teamMember.mbtiType" class="ms-auto">
              <a [routerLink]="teamMember.mbtiType ? ['/team', teamMember.memberId] : []" class="profileLink">
                <span *ngIf="isTeamMemberHovered[i]">View Profile</span>
                <span *ngIf="!isTeamMemberHovered[i]" class="uppercase">{{ teamMember.mbtiType }}</span>
                <span> »</span>
              </a>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="mobile d-block d-md-none">
    <div class="team-list-label">Team Members</div>
    <div class="scrolling-wrapper-flexbox">
      <div class="teamMember d-flex flex-column" *ngFor="let teamMember of teamMembers">
        <div class="initials" [ngStyle]="{ background: teamMember.color }">{{ teamMember.initials }}</div>
        <div class="name">
          <div *ngIf="teamMember.currentUser">You</div>
          <div *ngIf="!teamMember.currentUser">{{ teamMember.firstName }} {{ teamMember.lastName }}</div>
        </div>
        <div class="profile uppercase" *ngIf="teamMember.mbtiType">
          <a [routerLink]="teamMember.currentUser ? ['/results'] : teamMember.mbtiType ? ['/team', teamMember.memberId] : []">
            {{ teamMember.mbtiType }} »
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
